export const cibBigCartel = ["32 32","<path d='M16 17.421v-1.339c0-0.837 0.339-1.676 1.172-2.009l10.391-6.537c0.667-0.333 1.005-1.172 1.005-2.009v-5.527l-12.568 8.041-12.568-8.041v16.921c0 4.527 2.016 8.376 5.36 10.552l7.041 4.527 7.041-4.527c3.349-2.009 5.36-5.859 5.36-10.552v-7.541z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-big-cartel.js
// module id = null
// module chunks = 